document.addEventListener('DOMContentLoaded', () => {
  const dialogButtons = document.querySelectorAll('button[data-type="dropdown"]');

  dialogButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('data-target');
      const dropdown = document.querySelector(`.dropdown--content#${target}`);

      if (!dropdown) {
        return;
      }

      dropdown.setAttribute(
        'open',
        dropdown.getAttribute('open') !== 'true',
      );
    });

    document.body.addEventListener('click', (event) => {
      if (event.target.closest('.dropdown')) {
        return;
      }

      document.querySelectorAll('.dropdown--content').forEach((dropdown) => {
        dropdown.setAttribute('open', 'false');
      });
    });
  });

  document.querySelectorAll('.dropdown--link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      if(link.getAttribute('aria-current') === 'true') {
        return;
      }

      const form = link.closest('form');
      const inputLocale = form.querySelector('input[name="locale_code"')
      inputLocale.value = link.getAttribute('data-value');

      form.submit();
    });
  });
});
